const naturaloe = {
  FORMS: [
    {
      type: 'naturaloe-problemas-compra',
      name: 'naturaloePurchaseProblemsForm',
      message: {
        open: 'Opción Problemas Compra',
        send: 'Envío Formulario De Problemas compra'
      }
    },
    {
      type: 'naturaloe-cambio-direccion-entrega',
      name: 'naturaloeChangeDeliveryAddressForm',
      message: {
        open: 'Opción Cambio de Dirección Entrega',
        send: 'Envío Formulario De Cambio de Dirección Entrega'
      }
    },
    {
      type: 'naturaloe-estado-pedido',
      name: 'naturaloeOrderStatusForm',
      message: {
        open: 'Opción Estado de Pedido',
        send: 'Envío Formulario De Estado de Pedido'
      }
    },
    {
      type: 'naturaloe-problemas-pedido',
      name: 'naturaloeContactForm',
      message: {
        open: 'Opción Problemas de Pedidos',
        send: 'Envío Formulario De Problemas de Pedidos'
      }
    },
    {
      type: 'naturaloe-contact-form-order-status',
      name: 'naturaloeContactForm',
      message: {
        open: 'Opción Contacto',
        send: 'Envío Formulario De Contacto'
      }
    },
    {
      type: 'naturaloe-contact-form',
      name: 'naturaloePurchaseProblemsForm',
      message: {
        open: 'Opción Contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '621564dc169430271cf17b65',
    name: 'naturaloe',
    avatar: {
      name: 'Connie',
      header: 'https://chatbotqa.gatblac.com/static/avatar/naturaloe/avatar-reposo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/naturaloe/avatar-inactivo.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/naturaloe/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/naturaloe/avatar-reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#73ae45',
        borderColor: '#73ae45'
      }
    }
  }
}

export default naturaloe
